
import { defineComponent, onMounted, ref } from "vue";

export default defineComponent({
    name: "App",
    setup() {
        const obj = {
            a: 5,
            c: {
                b: [0],
            },
        };
        const count = ref(0);
        const demo = ref(obj);
        console.log('obj', demo);
        console.log('value', count);
        // 方法
        function updateCount() {
            // count 是一个Ref对象
            // count++;
            count.value++;
            demo.value.c.b.push(1);
        }

        const inputRef = ref<HTMLElement | null>(null);

        // 当页面加载完，文本框直接获取焦点
        onMounted(() => {
            inputRef.value && inputRef.value.focus();
        });

        // 返回一个对象
        return {
            count,
            demo,
            obj,
            updateCount,
            inputRef,
        };
    },
});
